import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

type SliderButtonValue = string | number;

type SliderButtonsProps = {
  value?: SliderButtonValue | null;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  error?: boolean;
  onChange?: (value: number) => void;
};

const MAX_VISIBLE_STEPS = 10;

const getButtonValues = (min = 0, max = 10, step = 1) => {
  const values: number[] = [];

  for (let value = min; value <= max; value += step) {
    values.push(value);
  }

  if (values.length <= MAX_VISIBLE_STEPS + 1) {
    return values;
  }

  const visibleStep = (max - min) / MAX_VISIBLE_STEPS;
  const visibleValues: number[] = [];

  for (let i = 0; i <= MAX_VISIBLE_STEPS; i += 1) {
    visibleValues.push(Number((min + visibleStep * i).toFixed(2)));
  }

  return visibleValues;
};

const SliderButtons = ({
  value,
  min = 0,
  max = 10,
  step = 1,
  disabled = false,
  error = false,
  onChange,
}: SliderButtonsProps) => {
  const hasSelectedValue =
  value !== undefined &&
  value !== null &&
  String(value).trim() !== '';

  const selectedValue = hasSelectedValue ? Number(value) : null;  
  const buttonValues = getButtonValues(min, max, step);

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {buttonValues.map((buttonValue) => {
        const isSelected = selectedValue !== null && selectedValue === buttonValue;

        return (
          <Button
            key={buttonValue}
            type="button"
            size="small"
            variant={isSelected ? 'contained' : 'outlined'}
            disabled={disabled}
            onClick={() => onChange?.(buttonValue)}
            sx={{
              minWidth: 42,
              color: isSelected
                ? "#fff"
                : error
                  ? "#d32f2f"
                  : "var(--app-primary, #2878d4)",
              borderColor: error
                ? "#d32f2f"
                : "var(--app-primary, #2878d4)",
              backgroundColor: isSelected
                ? "var(--app-primary, #2878d4)"
                : "transparent",
              "&:hover": {
                borderColor: error
                  ? "#d32f2f"
                  : "var(--app-primary, #2878d4)",
                backgroundColor: isSelected
                  ? "var(--app-primary, #2878d4)"
                  : error
                    ? "rgba(211, 47, 47, 0.08)"
                    : "rgba(40, 120, 212, 0.08)",
              },
            }}
          >
            {buttonValue}
          </Button>
        );
      })}
    </Box>
  );
};

export default SliderButtons;